import { createFileRoute } from "@tanstack/react-router";
import Spravato from "@/pages/Spravato";
import { buildHreflang } from "@/lib/i18n/locale";
export const Route = createFileRoute("/services/spravato")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "SPRAVATO® Treatment | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "SPRAVATO nasal spray for treatment-resistant depression in Coral Springs, FL. Learn how it works and if it may be right for you Free consultation available.",
        },
        {
          property: "og:title",
          content: "SPRAVATO® Treatment | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "SPRAVATO nasal spray for treatment-resistant depression in Coral Springs, FL. Learn how it works and if it may be right for you Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/services/spravato",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/services/spravato",
        },
        ...buildHreflang("/services/spravato"),
      ],
    };
  },
});
function RouteComponent() {
  return <Spravato />;
}
